import { render, staticRenderFns } from "./SpaceImport.vue?vue&type=template&id=cfbac69c&"
import script from "./SpaceImport.vue?vue&type=script&lang=js&"
export * from "./SpaceImport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports